import React from "react";
import PropTypes from "prop-types";
import {
    Modal,
    Card,
    CardBody,
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button
} from "reactstrap";
import { STORE_HANDLER_FORM_FIELDS } from "./formFields";

/**
 * Generic Store Handle Modal Component
 * @param {boolean} isOpen - Whether modal is open
 * @param {Function} toggle - Function to toggle modal
 * @param {Function} onSubmit - Submit handler
 * @param {Object} storeHandle - Store handle data
 * @param {Function} onInputChange - Input change handler
 * @param {string} mode - 'create' or 'edit'
 * @param {string} title - Modal title
 */
const StoreHandleModal = ({
    isOpen,
    toggle,
    onSubmit,
    storeHandle = {},
    onInputChange,
    mode = "create",
    title
}) => {
    const renderFormField = (field) => {
        const value = storeHandle[field.name] || "";
        const isEditMode = mode === "edit";
        const isReadOnly = isEditMode && field.name === "store";

        if (field.type === "checkbox") {
            return (
                <FormGroup className="row mb-4" key={field.name}>
                    <Label
                        htmlFor={field.id}
                        className="col-sm-3 col-form-label"
                    >
                        {field.label}
                    </Label>
                    <Col sm={8}>
                        <Input
                            type="checkbox"
                            name={field.name}
                            id={field.id}
                            onChange={onInputChange}
                            checked={storeHandle[field.name] || false}
                        />
                    </Col>
                </FormGroup>
            );
        }

        if (field.type === "textarea") {
            return (
                <FormGroup className="row mb-4" key={field.name}>
                    <Label
                        htmlFor={field.id}
                        className="col-sm-3 col-form-label"
                    >
                        {field.label}
                    </Label>
                    <Col sm={8}>
                        <Input
                            type="textarea"
                            name={field.name}
                            placeholder={field.placeholder}
                            className="form-control"
                            id={field.id}
                            value={value}
                            onChange={onInputChange}
                            rows={field.rows}
                            required={field.required}
                        />
                    </Col>
                </FormGroup>
            );
        }

        return (
            <FormGroup className="row mb-4" key={field.name}>
                <Label
                    htmlFor={field.id}
                    className="col-sm-3 col-form-label"
                >
                    {field.label}
                </Label>
                <Col sm={8}>
                    <Input
                        type={field.type}
                        name={field.name}
                        placeholder={isEditMode && field.name === "name" ? "Auto BCL Name" : field.placeholder}
                        className="form-control"
                        id={field.id}
                        value={value}
                        onChange={onInputChange}
                        required={field.required}
                        readOnly={isReadOnly}
                    />
                </Col>
            </FormGroup>
        );
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                    {title}
                </h5>
                <button
                    type="button"
                    onClick={toggle}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <Card>
                    <CardBody>
                        <Form onSubmit={onSubmit}>
                            {STORE_HANDLER_FORM_FIELDS.map(renderFormField)}
                            <FormGroup className="row justify-content-end">
                                <Col sm={9}>
                                    <div>
                                        <Button
                                            type="submit"
                                            color="primary"
                                            className="w-md"
                                        >
                                            {mode === "create" ? "Submit" : "Update"}
                                        </Button>
                                    </div>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </Modal>
    );
};

StoreHandleModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    storeHandle: PropTypes.object,
    onInputChange: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(["create", "edit"]),
    title: PropTypes.string.isRequired
};

export default StoreHandleModal;

